
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      pdfPathSD: '/pdf/valid/DPN-senha-digital.pdf',
      pdfPathSDP: '/pdf/valid/DPN-senha-digital-plus.pdf',
    }
  },
  computed: {
    ...mapGetters('unidade', ['unidadeInformation']),
    pathDPN() {
      if (this.unidadeInformation.unidade === 'senhadigital.com.br') {
        return this.pdfPathSD
      } else if (
        this.unidadeInformation.unidade.includes('senhadigitalplus.com.br')
      ) {
        return 'https://sdsolucoes.com.br/arquivo/DPN-senha-digital-plus.pdf'
      } else {
        return ''
      }
    },
  },
}
